// Cache the results from getting the user's authorization permissions from the service.
const cache = {};

export function configureAuthGuard($q, $state, $transitions, employeeService,
    permissionGrantService, sessionService, utilityService) {
    'ngInject';

    $transitions.onStart({ to: routeRequiresAuth }, function (transition) {
        utilityService.showLoading();
        const to = transition.$to();
        const returnUrl = $state.href(to);
        return sessionService.isAuthorized()
            .then(isAuthorized => {
                if (!isAuthorized) {
                    return $state.target("account.login", { returnUrl });
                }

                if (!ignoreRole(to)) {
                    // Only perform control access logic upon successful authentication.
                    return controlAccess();
                }
            }, () => $state.target("account.sessionExpired", { returnUrl }))

            .finally(() => utilityService.hideLoading());

        function controlAccess() {
            const stateName = transition.to().name;
            const permissionKey = getRoutePermissionKey(transition.to().$$state());

            let hasAccess = null;
            if (permissionKey) {
                hasAccess = permissionGrantService.hasPermission(permissionKey);
            } else {
                hasAccess = $q.resolve(cache[stateName] || employeeService.retrievePermissions({ stateName }))
                    .then(access => {
                        cache[stateName] = access;
                        return access && access.CanRead;
                    });
            }
            return $q.all([hasAccess, employeeService.hasOnboardingPermission()]).then(access => {
                console.log(access);
                var blockedNavs = ["navigation"];
                if (!access[0]) {
                    console.log(`Access denied to state ${stateName}, permission ${permissionKey}`);
                    return $state.target("persisted403");
                }
                if (!permissionKey) {
                    return;
                }
                if (access[1] && blockedNavs.some(nav => permissionKey.includes(nav)) && permissionKey !== 'navigation:applicationStatus' ) {
                    console.log(`Access denied to state ${stateName}, permission ${permissionKey}`);
                    return $state.target("persisted403");
                }
                //let onb = ;
                //onb.then((res) => {
                //    console.log(res);
                //    //if (res && permissionKey !== "navigation:applicationStatus") {
                //    //    console.log(`Access denied to state ${stateName}, permission ${permissionKey}`);
                //    //    return $state.target("persisted403");
                //    //}
                //    if (!access) {
                //        console.log(`Access denied to state ${stateName}, permission ${permissionKey}`);
                //        return $state.target("persisted403");
                //    }
                //});
            }).catch(ex => {
                //TODO: Retry. The permission check errored. The user might still be authorized.
                return $state.target("navigationFailed", { message: "Authorization could not be determined." });
            });
        }
    });

    function getRoutePermissionKey(route) {
        if (!route.data || !route.data.permissionKey) {
            if (!route.parent) {
                return null;
            }
            // Permissions bubble up if the route being transitioned doesn't specify a permission requirement.
            // Note that the permissions checks do not stack (the check closest to the original route is always used).
            return getRoutePermissionKey(route.parent);
        }
        return route.data.permissionKey;
    }
}

/**
 * Return whether the route can be reached by any user role.
 * @param {any} route The route being transitioned.
 */
function ignoreRole(route) {
    return route.data && route.data.ignoreRole;
}

/**
 * Return whether the route can only be reached by authenticated users.
 * @param {any} route The route being transitioned.
 */
function routeRequiresAuth(route) {
    if (route.data && route.data.skipAuthGuard) {
        return false;
    }
    return !route.data || !route.data.allowAnonymous;
}
